import React from 'react';
import image from '../assets/comingsoon.jpg'
const Blogs = () => {
    return (
        <div className='max-w-lg h-screen mx-auto '>
            <img src={image} alt=""  />
            
        </div>
    );
};

export default Blogs;